export default {
    specs: [],
    saved_specs: ([] as string[]),
}
